(() => {
  const BOUND_FLAG = '__productGalleryArrowsBound';

  if (window[BOUND_FLAG]) {
    return;
  }

  window[BOUND_FLAG] = true;

  /**
   * 返回画廊内所有可用于媒体切换的缩略图按钮。
   * 缩略图虽然被 CSS 隐藏，但仍保留在 DOM 中，
   * 从而继续使用 Shopify 自带 media-gallery.js 的切换逻辑。
   */
  const getThumbnailButtons = (gallery) => {
    return Array.from(
      gallery.querySelectorAll('.thumbnail-list button.thumbnail'),
    ).filter((button) => !button.disabled);
  };

  /**
   * 找到当前媒体对应的缩略图索引。
   */
  const getCurrentIndex = (gallery, thumbnails) => {
    const currentThumbnailIndex = thumbnails.findIndex((thumbnail) =>
      thumbnail.hasAttribute('aria-current'),
    );

    if (currentThumbnailIndex >= 0) {
      return currentThumbnailIndex;
    }

    const activeMedia = gallery.querySelector(
      '.product__media-item.is-active',
    );

    const activeMediaId = activeMedia?.dataset.mediaId;

    if (!activeMediaId) {
      return 0;
    }

    const matchingIndex = thumbnails.findIndex((thumbnail) => {
      const target = thumbnail.dataset.target || '';
      return target.endsWith(activeMediaId);
    });

    return matchingIndex >= 0 ? matchingIndex : 0;
  };

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-gallery-direction]');

    if (!arrow) {
      return;
    }

    const gallery = arrow.closest('media-gallery');

    if (!gallery) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const thumbnails = getThumbnailButtons(gallery);

    if (thumbnails.length < 2) {
      return;
    }

    const direction = Number(arrow.dataset.galleryDirection);

    if (direction !== -1 && direction !== 1) {
      return;
    }

    const currentIndex = getCurrentIndex(gallery, thumbnails);

    /*
     * 循环切换：
     * 第一张向左跳转最后一张；
     * 最后一张向右跳转第一张。
     */
    const nextIndex =
      (currentIndex + direction + thumbnails.length) % thumbnails.length;

    thumbnails[nextIndex].click();
  });
})();